const FAMILY_BY_TYPE = {
  input: 'input',
  multiLine: 'input',
  richText: 'input',
  url: 'input',
  reference: 'input',
  color: 'input',
  json: 'input',
  int: 'int',
  decimal: 'int',
  boolean: 'boolean',
  date: 'date',
  datetime: 'date',
  enum: 'enum',
  money: 'int',
  weight: 'int',
  dimension: 'int',
  volume: 'int',
  rating: 'int',
  link: 'input',
  file: 'input',
  image: 'input',
  video: 'input',
};

const TEXT_OPERATORS = ['equals', 'contains', 'startsWith', 'endsWith', 'notEquals', 'isSet', 'notSet'];
const NUMBER_OPERATORS = ['equals', 'notEquals', 'gt', 'lt', 'between', 'isSet', 'notSet'];
const BOOLEAN_OPERATORS = ['equals', 'isSet', 'notSet'];
const DATE_OPERATORS = [
  'equals',
  'notEquals',
  'gt',
  'lt',
  'between',
  'isSet',
  'notSet',
  'today',
  'yesterday',
  'lastweek',
  'lastmonth',
  'last90days',
];
const ENUM_OPERATORS = [
  'oneOf',
  'noneOf',
  'allOf',
  'oneOfExceptOneOf',
  'oneOfExceptAllOf',
  'allOfExceptOneOf',
  'allOfExceptAllOf',
  'isSet',
  'notSet',
];
const MULTIPLE_ONLY_ENUM_OPERATORS = ['oneOfExceptAllOf', 'allOfExceptAllOf', 'allOf'];

function resolveFieldFamily(type) {
  return FAMILY_BY_TYPE[type] || null;
}

/**
 * Builds a search-filter descriptor for a product custom attribute (`meta.<title>`).
 * Mirrors `@picsio/db` products meta `availableFilters` shape for live UI updates.
 *
 * @param {Object} field - product attribute schema item
 * @returns {Object|null}
 */
export default function buildMetaAvailableSearchFilter(field) {
  if (!field || field.type === 'separator') return null;

  const family = resolveFieldFamily(field.type);
  if (!family) return null;

  const searchFilter = {
    customField: field,
  };

  if (family === 'input') {
    searchFilter.operators = TEXT_OPERATORS;
    searchFilter.type = 'text';
    searchFilter.defaultOperator = 'equals';
  }

  if (family === 'int') {
    searchFilter.operators = NUMBER_OPERATORS;
    searchFilter.type = 'number';
    searchFilter.defaultOperator = 'equals';
  }

  if (family === 'boolean') {
    searchFilter.operators = BOOLEAN_OPERATORS;
    searchFilter.type = 'boolean';
    searchFilter.defaultOperator = 'equals';
  }

  if (family === 'date') {
    searchFilter.operators = DATE_OPERATORS;
    searchFilter.type = 'date';
    searchFilter.defaultOperator = 'equals';
  }

  if (family === 'enum') {
    let operators = ENUM_OPERATORS;
    if (!field.multiple) {
      operators = operators.filter((name) => !MULTIPLE_ONLY_ENUM_OPERATORS.includes(name));
    }
    searchFilter.operators = operators;
    searchFilter.type = 'enum';
    searchFilter.multiple = !!field.multiple;
    searchFilter.defaultOperator = 'oneOf';
    if (field.options) {
      searchFilter.options = field.options;
    }
  }

  return searchFilter;
}
